import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changePasswordAction } from "../../../store/slices/authSlice";
import AuthenticationLeftContent from "../../../components/common/AutenticationLeftContent";
import AuthenticationTextInput from "../../../components/common/TextInput/AuthenticationTextInput";
import PrimaryButton from "../../../components/common/PrimaryButton";
import Heading from "../../../components/common/AutenticationTitles/Heading";
import Subtitle from "../../../components/common/AutenticationTitles/Subtitle";

const ResetPasswordPage = () => {
  const location = useLocation();
  const code = location.state?.code;
  const email = location.state?.email;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLaptop = useMediaQuery(theme.breakpoints.down("lg"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");

  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.password) newErrors.password = "New Password is required";
    else if (form.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!form.confirmPassword)
      newErrors.confirmPassword = "Confirm Password is required";
    else if (form.password !== form.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const result = await dispatch(changePasswordAction({ email, code, newPassword: form.password, confirmPassword: form.confirmPassword }));
      if (changePasswordAction.fulfilled.match(result)) {
        navigate("/login");
      }
    } catch (err) {}
  };

  return (
    <Box sx={{ 
      display: isMobile ? "block" : "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      minHeight: "100vh", 
      backgroundColor: isMobile ? "#fff" : "#f5f5f5", 
      padding: isTablet ? "30px" : isMobile ? "0px" : "20px" 
    }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : isTablet ? "column" : "row",
          backgroundColor: "#fff",
          borderRadius: isMobile ? "12px" : isTablet ? "12px" : "22px",
          boxShadow: isMobile ? "unset" : "-2px 0 10px 0 rgba(102, 102, 102, 0.01), 0 16px 10px 0 rgba(102, 102, 102, 0.10), 0 -2px 16px 0 rgba(102, 102, 102, 0.06)",
          maxWidth: "1066px",
          width: "100%",
          margin: isMobile ? "0" : isTablet ? "0px auto" : "40px auto",
          minHeight: isMobile ? "auto" : "525px",
          overflow: "hidden",
          alignItems: "center",
          padding: isMobile ? "0px" : isTablet ? "0px" : "20px 0 20px 20px",
          height: isMobile ? "100vh" : isTablet ? "90vh" : "auto",
        }}
      >
      <Box className="left-width" flex={1} sx={{maxWidth:isMobile ? "100%": isTablet ? "100%" : isLaptop? "300px" :"499px"}}>
                <AuthenticationLeftContent onClose={() => {}} showCloseButton={false} />
              </Box>
        
        <Box className="right-content" flex={1} p={isMobile ? 2 : isTablet ? 2 : 4} sx={{
          maxWidth:isMobile?"100%":isLaptop?"390px": "100%",
          marginInline: isMobile ? "0" : isTablet ? "0" : "auto",
          height: isMobile ? "50vh" : isTablet ? "60vh" : "auto",
          overflow: isMobile ? "auto" : isTablet ? "auto" : "visible",
          display: "flex",
          flexDirection: "column",
          justifyContent: isMobile ? "flex-start" : "center",
          width: isMobile ? "100%" : isTablet ? "100%" : "auto",
          position: "relative",
          borderRadius: isMobile ? "0 0 12px 12px" : isTablet ? "0 0 12px 12px" : "0"
        }}>
          <Heading sx={{ mb: 1, fontSize: isMobile ? "24px" : "inherit" }}>
            Reset Password
          </Heading>
          <Subtitle sx={{ mb: isMobile ? 3 : 4, fontSize: isMobile ? "16px" : "inherit" }}>
            Enter your new password below
          </Subtitle>
          <form onSubmit={handleSubmit}>
            <AuthenticationTextInput
              label="New Password"
              type="password"
              placeholder="Enter New Password"
              value={form.password}
              onChange={handleChange("password")}
              error={errors.password}
              helperText={errors.password}
              required
              sx={{ mb: isMobile ? 2 : 3 }}
            />
            <AuthenticationTextInput
              label="Confirm Password"
              type="password"
              placeholder="Confirm Password"
              value={form.confirmPassword}
              onChange={handleChange("confirmPassword")}
              error={errors.confirmPassword}
              helperText={errors.confirmPassword}
              required
              sx={{ mb: isMobile ? 3 : 4 }}
            />
            <PrimaryButton
              sx={{
                width: "100%",
                height: isMobile ? "44px" : "48px",
                fontSize: isMobile ? "16px" : "18px",
                fontWeight: 600,
                background: "#141414",
                borderRadius: "10px",
                boxShadow: "none",
                mt: isMobile ? 1 : 2,
                mb: isMobile ? 1 : 2,
                "&:hover": {
                  background: "#222",
                },
              }}
            >
              Reset Password
            </PrimaryButton>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ResetPasswordPage;